<template>
  <div
    :class="$style.root"
  >
    <h1 :class="$style.heading">
      <CoreDateTimeRangeComponent
        :dateStart="localizedData?.date_posted"
        :class="$style.date"
      />
      {{ title }}
    </h1>

    <CoreImageComponent
      v-if="localizedData?.cover_image?.data?.attributes"
      :image="localizedData?.cover_image?.data?.attributes"
      :class="$style.image"
    />

    <CoreBlocksComponent
      v-if="localizedData.blocks"
      :blocks="localizedData.blocks"
      :withinModal="true"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const title = computed(() => i18nGetLocalizedString(localizedData?.value?.titles))

</script>

<style module>
.root {
  position: relative;

  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 2);
}

.heading {
  composes: reset-heading font-size-large from global;
  composes: container--default from global;

  text-align: center;
  margin-bottom: calc(var(--width--button--round) - var(--unit--vertical));
}

.date {
  composes: font-size-medium from global;
  text-align: center;
  display: block;
  color: var(--color--secondary);
}

.image {
  composes: container--default from global;
}

</style>
